interface FamilyCardProps {
  title: string;
  icon: string;
  description: string;
  onClick: () => void;
  bgImage?: string;
}

export default function FamilyCard({ title, icon, description, onClick, bgImage }: FamilyCardProps) {
  return (
    <div 
      className="relative bg-white rounded-2xl p-6 shadow-sm border border-gray-100 overflow-hidden cursor-pointer transform transition-all duration-200 hover:scale-105"
      onClick={onClick}
    >
      {bgImage && (
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      )}
      <div className="relative z-10">
        <div className="w-12 h-12 bg-[#5B9BD5]/10 rounded-full flex items-center justify-center mb-4">
          <i className={`${icon} text-2xl text-[#5B9BD5]`}></i>
        </div>
        <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
}